import { Component, inject } from '@angular/core';
import { HxDateRangeSelectComponent, HxLoaderComponent, HxStoreSelectComponent } from 'hx-component';
import { TranslocoPipe } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';
import { DecimalPipe, NgForOf, NgIf } from '@angular/common';
import { CancelOrderModel, DateRange, extractDateRange, extractDefaultStoreIds, HxReportService, HxUiLabelPipe, isoDate, toRouterQueryParams } from 'hx-services';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-cancel-orders',
  templateUrl: './cancel-orders.component.html',
  styleUrls: ['./cancel-orders.component.css'],
  imports: [
    HxDateRangeSelectComponent,
    HxStoreSelectComponent,
    TranslocoPipe,
    HxLoaderComponent,
    FormsModule,
    NgForOf,
    NgIf,
    DecimalPipe,
    RouterLink,
    HxUiLabelPipe
  ]
})
export class CancelOrdersComponent {
  params: {
    storeIds?: number[],
    date?: DateRange,
  } = {};
  isLoading = {
    list: false,
    generate: false,
  };
  list: CancelOrderModel[] = [];

  private readonly reportService = inject(HxReportService);
  private readonly aRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);

  constructor() {
    this.aRoute.queryParamMap.pipe(takeUntilDestroyed()).subscribe(async paramMap => {
      const asArrFn = (name: string, mapFn: (key: string) => any) => paramMap.get(name)?.split(',').map(mapFn) ?? undefined;
      this.params.date = extractDateRange('date', paramMap) ?? {from: isoDate(new Date()), to: isoDate(new Date())};
      this.params.storeIds = asArrFn('storeIds', str => Number(str)) ?? extractDefaultStoreIds();
      if (this.params.storeIds) {
        this.load();
      }
    });
  }

  resetFilter() {
    this.params.date = {from: isoDate(new Date()), to: isoDate(new Date())};
    this.navigate();
  }

  navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  async load() {
    this.list = [];
    this.isLoading.list = true;
    try {
      this.list = await this.reportService.getCancelOrderReport({ fromDate: this.params.date.from, toDate: this.params.date.to, storeIds: this.params.storeIds });
    } finally {
      this.isLoading.list = false;
    }
  }
}
